// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin {
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}
.admin .top-bar {
  background-color: #fff;
  border-bottom: 1px solid black;
}
.admin .top-bar__logo-container__button {
  border-color: black;
  color: black;
}
.admin__container {
  position: relative;
  display: flex;
  flex-direction: row;
}
.admin__sidebar {
  width: 250px;
  height: 90vh;
  border-right: 1px solid black;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  flex-direction: column;
}
.admin__sidebar__option {
  display: flex;
  gap: 5px;
  align-items: center;
  width: 80%;
  padding: 8px;
  cursor: pointer;
  text-align: start;
}
.admin__sidebar .selected {
  background-color: rgba(255, 214, 166, 0.4196078431);
  border-radius: 5px;
}
.admin__content {
  padding-left: 13%;
  overflow: auto;
  max-height: 90vh;
  height: 100%;
  width: 82%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.admin__content .chip {
  border: 0.0825rem solid #E3E8EC;
  color: #EE926B;
  font-weight: 500;
  background-color: #fff;
}
.admin__content__button-container {
  height: 3rem;
  width: 70%;
  margin-top: 6rem;
  display: flex;
  flex-direction: row;
  gap: 20px;
}
.admin__content__button-container__button {
  width: 14rem;
  height: 2rem;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 214, 166, 0.4196078431);
  cursor: pointer;
}
.admin__content table {
  height: fit-content;
  border-collapse: collapse;
  width: 70%;
  box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.15);
  margin-bottom: 20px;
}
.admin__content th {
  border: 0.0625rem solid #ddd;
  padding: 0.67rem;
  border-top: none;
}
.admin__content th:first-child {
  border-left: none;
}
.admin__content th:last-child {
  border-right: none;
}
.admin__content td:not(:last-child) {
  border-left: 0.0625rem solid #ddd;
  border-right: 0.0625rem solid #ddd;
  padding: 1rem;
  text-align: center;
  width: fit-content;
  text-wrap: nowrap;
}
.admin__content td:not(:last-child):first-child {
  border-left: none;
}
.admin__content th {
  color: #666;
  font-size: 0.8125rem;
  font-weight: 500;
}
.admin__content .modify {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  height: 100%;
}

.p-inputtext .p-component {
  color: black !important;
}

.p-multiselect {
  display: flex;
  align-items: center;
  background-color: #4BABB9;
  border-radius: 8px;
  color: black !important;
  padding: 7px;
  box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1019607843);
  text-align: left;
  height: 32.5px;
  border: 1px solid #4BABB9;
  width: 120px !important;
  cursor: pointer;
}

.p-multiselect-panel {
  background-color: #4BABB9;
  border: 1px solid #4BABB9;
  border-radius: 8px;
}

.p-multiselect-item {
  padding: 8px;
}

.p-multiselect-filter-container {
  background-color: #4BABB9;
  border: 1px solid #4BABB9;
  border-radius: 8px;
  padding: 8px;
}

.p-calendar .p-inputtext {
  display: flex;
  align-items: center;
  background-color: #4BABB9;
  border-radius: 8px;
  color: black !important;
  padding: 7px;
  box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1019607843);
  text-align: left;
  height: 32.5px;
  border: 1px solid #4BABB9;
  width: 195px !important;
  cursor: pointer;
}
.p-calendar .p-inputtext ::placeholder {
  color: black !important;
}

.p-datepicker {
  background-color: #4BABB9;
  border: 1px solid #4BABB9;
  border-radius: 8px;
  width: 250px;
}

.p-icon.p-multiselect-filter-icon {
  visibility: collapse;
}

input.p-inputtext.p-component::placeholder {
  color: black !important;
  font-size: 16px;
}

input.p-inputtext.p-component {
  color: black !important;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/features/admin/components/admin/admin.scss"],"names":[],"mappings":"AAAA;EAUI,aAAA;EACA,sBAAA;EACA,kBAAA;AARJ;AAHE;EACE,sBAAA;EACA,8BAAA;AAKJ;AAHI;EACE,mBAAA;EACA,YAAA;AAKN;AACE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AACJ;AACE;EACE,YAAA;EACA,YAAA;EACA,6BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;AACJ;AAAI;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAEN;AAAI;EACE,mDAAA;EACA,kBAAA;AAEN;AACI;EACE,iBAAA;EACF,cAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AACJ;AAAQ;EACE,+BAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AAEV;AAAQ;EACE,YAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAEV;AADU;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mDAAA;EACA,eAAA;AAGZ;AAAQ;EACI,mBAAA;EACA,yBAAA;EACA,UAAA;EACA,2CAAA;EACA,mBAAA;AAEZ;AACU;EACE,4BAAA;EACA,gBAAA;EACA,gBAAA;AACZ;AAAY;EACI,iBAAA;AAEhB;AAAY;EACI,kBAAA;AAEhB;AACU;EACE,iCAAA;EACA,kCAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AACZ;AACY;EACI,iBAAA;AAChB;AAGU;EACE,WAAA;EACA,oBAAA;EACA,gBAAA;AADZ;AAGU;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;AADZ;;AAOA;EACA,uBAAA;AAJA;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,8DAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;AAJF;;AAOA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;AAJF;;AAOA;EACE,YAAA;AAJF;;AAMA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EAIA,YAAA;EACA,8DAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;AANF;AAHE;EACE,uBAAA;AAKJ;;AAKA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AAFF;;AAIA;EACE,oBAAA;AADF;;AAGA;EACE,uBAAA;EACA,eAAA;AAAF;;AAEA;EACE,uBAAA;EACA,eAAA;AACF","sourcesContent":[".admin{\n  .top-bar {\n    background-color: #fff;\n    border-bottom: 1px solid black;\n\n    &__logo-container__button{\n      border-color: black;\n      color: black;\n    }\n  }\n    display: flex;\n    flex-direction: column;\n    overflow-y: hidden;\n  &__container{\n    position: relative;\n    display: flex;\n    flex-direction: row;\n  }\n  &__sidebar{\n    width: 250px;\n    height: 90vh;\n    border-right: 1px solid black;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap:30px;\n    flex-direction: column;\n    &__option{\n      display: flex;\n      gap:5px;\n      align-items: center;\n      width: 80%;\n      padding: 8px;\n      cursor: pointer;\n      text-align: start;\n    }\n    .selected{\n      background-color: #FFD6A66B;\n      border-radius: 5px;\n    }\n  }\n    &__content{\n      padding-left: 13%;\n    overflow: auto;\n    max-height: 90vh;\n    height: 100%;\n    width: 82%;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n        .chip{\n          border: 0.0825rem solid #E3E8EC;\n          color:#EE926B;\n          font-weight: 500;\n          background-color: #fff;\n        }\n        &__button-container{\n          height: 3rem;\n          width: 70%;\n          margin-top: 6rem;\n          display: flex;\n          flex-direction: row;\n          gap: 20px;\n          &__button{\n            width: 14rem;\n            height: 2rem;\n            border-radius: 5px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            background-color: #FFD6A66B;\n            cursor: pointer;\n          }\n        }\n        table {\n            height: fit-content;\n            border-collapse: collapse;\n            width: 70%;\n            box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.15);\n            margin-bottom: 20px;\n          }\n          \n          th {\n            border: 0.0625rem solid #ddd;\n            padding: 0.67rem;\n            border-top: none;\n            &:first-child {\n                border-left: none;\n            }\n            &:last-child {\n                border-right: none;\n            }\n          }\n          td:not(:last-child) {\n            border-left: 0.0625rem solid #ddd;\n            border-right: 0.0625rem solid #ddd;\n            padding: 1rem;\n            text-align: center;\n            width: fit-content;\n            text-wrap: nowrap;\n          \n            &:first-child {\n                border-left: none;\n            }\n          }\n          \n          th {\n            color: #666;\n            font-size: 0.8125rem;\n            font-weight: 500;\n          }\n          .modify{\n            cursor: pointer;\n            display: flex;\n            flex-direction: row;\n            justify-content: space-around;\n            align-items: center;\n            height: 100%;\n          }\n          \n    }\n}\n\n.p-inputtext .p-component{\ncolor: black !important;\n}\n\n.p-multiselect{\n  display: flex;\n  align-items: center;\n  background-color: #4BABB9;\n  border-radius: 8px;\n  color: black !important;\n  padding: 7px;\n  box-shadow: 0px 6px 58px 0px #C4CBD61A;\n  text-align: left;\n  height: 32.5px;\n  border : 1px solid #4BABB9;\n  width: 120px !important;\n  cursor: pointer;\n}\n\n.p-multiselect-panel{\n  background-color: #4BABB9;\n  border: 1px solid #4BABB9;\n  border-radius: 8px;\n}\n\n.p-multiselect-item{\n  padding: 8px;\n}\n.p-multiselect-filter-container{\n  background-color: #4BABB9;\n  border: 1px solid #4BABB9;\n  border-radius: 8px;\n  padding: 8px;\n}\n\n.p-calendar .p-inputtext{\n  display: flex;\n  align-items: center;\n  background-color: #4BABB9;\n  border-radius: 8px;\n  color: black !important;\n  ::placeholder{\n    color: black !important;\n  }\n  padding: 7px;\n  box-shadow: 0px 6px 58px 0px #C4CBD61A;\n  text-align: left;\n  height: 32.5px;\n  border : 1px solid #4BABB9;\n  width: 195px !important;\n  cursor: pointer;\n}\n.p-datepicker{\n  background-color: #4BABB9;\n  border: 1px solid #4BABB9;\n  border-radius: 8px;\n  width: 250px;\n}\n.p-icon.p-multiselect-filter-icon{\n  visibility: collapse;\n}\ninput.p-inputtext.p-component::placeholder{\n  color: black !important;\n  font-size: 16px;\n}\ninput.p-inputtext.p-component{\n  color: black !important;\n  font-size: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
